import { useLazyGetLocaleKeysQuery } from "@store/apis/magicoApi";
import i18next from "i18next";
import { useCallback } from "react";

export const useRemoteTranslations = () => {
  const [trigger] = useLazyGetLocaleKeysQuery();

  const loadTranslations = useCallback(async (appId: number) => {
    const result = await trigger({ id: appId });

    if (result.error) {
      console.warn("[i18n] Failed to load remote translations:", result.error);
      return;
    }

    if (!result.data?.remoteLocaleKeys) return;

    for (const [lang, keys] of Object.entries(result.data.remoteLocaleKeys)) {
      i18next.addResourceBundle(lang, "translation", keys, true, true);
    }
  }, [trigger]);

  return { loadTranslations };
};
